import { useOutletContext, useParams } from 'react-router-dom';
import { ContractorDetail } from '@/components/contractors/ContractorDetail';
import type { AppShellContext } from '@/components/layout/AppShell';

export function ContractorDetailPage() {
  const { nip, companyName } = useOutletContext<AppShellContext>();
  const { contractorId } = useParams<{ contractorId: string }>();

  if (!contractorId) return null;

  // Keyed by id: switching contractors remounts the view, so nothing of the
  // previous one (data, dialog, a late response) carries over.
  return (
    <ContractorDetail
      key={contractorId}
      companyNip={nip}
      companyName={companyName}
      contractorId={contractorId}
    />
  );
}
